export default __webpack_public_path__ + "static/img/mode-arrow.3cc18bc.svg";